import React from "react";
import { Breadcrumbs, Divider, Stack, useTheme, useViewport } from "@bookingcom/bui-react";
import { t } from "@bookingcom/lingojs-core";
import { useI18n } from "@bookingcom/lingojs-react";
import useCreateUrl from "../../../hooks/useCreateUrl.js";
import ConfirmationController from "../ConfirmationController/index.js";
import { CheckInInfoCard } from "./CheckinInfoCard.js";
import TwoColumnLayout from "../TwoColumnLayout/index.js";
import { CheckinHeader } from "./CheckinHeader.js";
import { CheckinHowTo } from "./CheckinHowTo.js";
import { CheckinSegmentHeader } from "./CheckinSegmentHeader.js";
import useIsPostBookingRoute from "../../../hooks/useIsPostBookingRoute.js";
export const WebCheckinInnerDesktop = ({ order, segment, filteredLegsWithOpenedCheckIn }) => {
    const i18n = useI18n();
    const theme = useTheme();
    const { createUrl } = useCreateUrl();
    const { isLarge } = useViewport();
    const isPostBooking = useIsPostBookingRoute();
    const isPostBookingNonLarge = isPostBooking && !isLarge;
    const content = (React.createElement("div", { style: { marginBottom: theme.units.spacing_8x } },
        React.createElement(Stack, { gap: 8 },
            React.createElement(CheckinHowTo, { order: order }),
            React.createElement(Divider, null),
            React.createElement(Stack, { gap: 4 },
                React.createElement(CheckinSegmentHeader, { segment: segment, showSubHeader: filteredLegsWithOpenedCheckIn.length === 1, showMultiPnrAlert: filteredLegsWithOpenedCheckIn.length > 1 }),
                filteredLegsWithOpenedCheckIn.map(({ leg, checkinInfoForLeg }) => {
                    const { legIdentifier: { segmentIndex, legIndex }, isOnlineCheckinOpen } = checkinInfoForLeg;
                    return (React.createElement(CheckInInfoCard, { key: legIndex, leg: leg, segmentIndex: segmentIndex, legIndex: legIndex, openCheckin: isOnlineCheckinOpen, checkInInfo: checkinInfoForLeg, showHeader: filteredLegsWithOpenedCheckIn.length > 1, showVuelingAlert: true }));
                })))));
    return (React.createElement(ConfirmationController, null, () => (React.createElement("main", null,
        React.createElement(Breadcrumbs, { back: true, items: [
                {
                    text: i18n.trans(t("flights_pb_checkin_navigation")),
                    href: createUrl(`/booking/order-details/${order?.orderToken}`)
                }
            ], attributes: { style: { paddingBottom: theme.units.spacing_2x } } }),
        React.createElement(Stack, { gap: 6 },
            React.createElement(CheckinHeader, { segment: segment }),
            isPostBookingNonLarge ? content : React.createElement(TwoColumnLayout, null, content))))));
};
